import React from 'react';

const CanvasDataContext = React.createContext('canvasData');

export default CanvasDataContext;
